import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/shared/components/ui/card';

export const ErrorCard = ({
  title,
  message,
  buttonText,
  onButtonClick,
}: {
  title: string;
  message: string;
  buttonText?: string;
  onButtonClick?: () => void;
}) => {
  return (
    <Card variant={'styled'} wrapWithStars>
      <CardHeader className="items-center space-y-14 pt-14">
        <CardTitle className="text-4xl font-medium text-destructive">
          {title}
        </CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col items-center gap-4 pt-6">
        <p className="text-center text-destructive">{message}</p>
        {buttonText && onButtonClick && (
          <button onClick={onButtonClick} className="text-blue-500 underline">
            {buttonText}
          </button>
        )}
      </CardContent>
    </Card>
  );
};
